import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { Search } from 'semantic-ui-react';

import clsx from 'clsx';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';

import useStyleRuleConfigurations from 'components/modules/style-rules/hooks/useStyleRuleConfigurations';
import { StyleRuleConfigurationPropType } from 'components/modules/style-rules/types';

import { RESULTS_LIMIT } from './RawEditField.constants';
import { getAllResults, searchResults } from './RawEditField.utils';

import './RawEditField.scss';

const propTypes = {
  styleRuleConfiguration: StyleRuleConfigurationPropType,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onResultSelect: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

const defaultProps = {
  styleRuleConfiguration: {},
  value: '',
  onChange: null,
  onResultSelect: null,
  disabled: false,
  className: '',
};

export default function RawEditField({
  styleRuleConfiguration,
  value,
  onChange: onChangeProp,
  onResultSelect: onResultSelectProp,
  disabled,
  className,
}) {
  const { styleRuleConfigurations } = useStyleRuleConfigurations();

  const [results, setResults] = useState([]);
  const [touched, setTouched] = useState(false);

  const { defaultValue = '', name } = styleRuleConfiguration || {};

  useEffect(() => {
    if (!touched) {
      setResults([]);
      return;
    }

    if (_isEmpty(value) || !value.startsWith('@')) {
      setResults([]);
      return;
    }

    const allResults = getAllResults(name, styleRuleConfigurations);

    if (value === '@') {
      setResults(allResults.slice(0, RESULTS_LIMIT));
      return;
    }

    const newResults = searchResults(allResults, value);
    setResults(newResults);
  }, [value]);

  function onSearchChange(event, target) {
    setTouched(true);

    if (!_isNil(onChangeProp)) {
      onChangeProp(event, target);
    }
  }

  function onResultSelect(event, target) {
    const newValue = _get(target, 'result.key', '');
    const newTarget = { ...target, value: newValue };
    const newEvent = { ...event, target: newTarget };

    if (!_isNil(onResultSelectProp)) {
      onResultSelectProp(newEvent, newTarget);
    } else if (!_isNil(onChangeProp)) {
      onChangeProp(newEvent, newTarget);
    }

    setResults([]);
  }

  const finalClassName = clsx({ 'raw-edit-field': true, [className]: !!className });

  return (
    <Search
      className={finalClassName}
      value={value || ''}
      onChange={onSearchChange}
      placeholder={defaultValue}
      icon={null}
      onSearchChange={onSearchChange}
      results={results}
      onResultSelect={onResultSelect}
      disabled={disabled}
    />
  );
}

RawEditField.propTypes = propTypes;
RawEditField.defaultProps = defaultProps;
